
export const de = {
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    preview: "Vorschau",
    generate: "Erstellen",
    reset: "Passwort ändern",
    invalid: "Ungültige Datei"
  },
  auth: {
    email: "Email",
    pwd: "Passwort",
    login: "Anmelden",
    logout: "Abmelden",
    welcome: "Willkommen, {name}!",
  },
 
   ui: {
   searchorder:"Search Event...",
   excludeorders:"Show past events",
error: "Fehler",
main: "Main Settings",
branding: "Branding",
access: "Access",
features: "Features",
links: "Links",
live:"Live",
variables: "Text Variablen",
events: "Events",
calendar: "Kalender",
urlshortener: "URL Shortener",
datadeleted: "Daten gelöscht",
whatInformationDoYouWantToDelete: "Welche Informationen möchten Sie löschen?",
deleteEntireEvent: "!!! GANZES EVENT LÖSCHEN !!!",
deleteEventData: "Event Daten löschen",

  }
} as const;